import { CoreMenu } from "src/@core/types";

export const customerPortalMenu: CoreMenu[] = [
  {
    id: 'Agreements',
    title: 'Agreements',
    type: 'item',
    icon: 'agreement.svg',
    url: '/invoicing/customer-portal/agreements',
    role: {
      roles: ['customer'],
      right: '',
    },
  },
  {
    id: 'Invoicing',
    title: 'Invoicing',
    type: 'item',
    icon: 'invoice.svg',
    url: '/invoicing/customer-portal/invoicing',
    role: {
      roles: ['customer'],
      right: '',
    },
  },
];
